module.exports = __webpack_public_path__ + "media/images/icons/dotted_line-a8f97c6ee778830b102fc8ee51cbfb36.svg";